import qs from "qs";
import axios from "utils/axios";

import { API } from "constants/";

// Type
import { AxiosResponse } from "axios";
import { AssessmentCentreResponse } from "./assessmentCentre.types";

export type TAssessmentCentreFiltersPayload = {
    filter_name: string;
    filter_pace_status: string[];
    filter_teams: string[];
    order_by: string;
    page_size: number;
    page_no: number;
};

export const assessmentCentreFilters = {
    filter_name: "",
    filter_pace_status: [""],
    filter_teams: [""],
    order_by: "name,asc",
    page_size: 25,
    page_no: 1,
};

export const fetchAssessmentCentreUsers = (
    filters: Partial<TAssessmentCentreFiltersPayload> = assessmentCentreFilters
): Promise<AxiosResponse<AssessmentCentreResponse>> => {
    return axios.get(`${API.SYSADMIN.PACE_PORTAL}?${qs.stringify(filters, { arrayFormat: "repeat" })}`);
};

export type updateReminderByUserIdPayload = {
    invite_list: {
        invitee_user_id: number;
        org_id: number;
        message?: string;
    }[];
};

export const updateReminderByUserId = (inviteList: updateReminderByUserIdPayload): Promise<AxiosResponse<string>> => {
    return axios.patch(`${API.SYSADMIN.SEND_REMINDER_BY_USER_ID}`, inviteList);
};
